import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Countries } from '@shared/interfaces/account/countries.interface';
import { Tag } from '@shared/interfaces/project/tag.interface';
import { Range } from '@shared/interfaces/project/range.interface';
import { Config } from '@shared/config';
import { Response } from '@shared/models/response.model';
import { ProjectPublish, ProjectStatus } from '@shared/interfaces/project/project.interface';
import { Project } from '@shared/models/project.model';
import { UploadImg } from '@shared/interfaces/project/upload-img.interface';
import { SuccessRes } from '@shared/interfaces/success-res.interface';
import { RoutesPath } from '@shared/routes-path';
import { BaseProjectComponent } from '../../components/base-project.component';
import { FileUploadSuccess } from '@shared/interfaces/project/file-upload-success.interface';
import * as moment from 'moment';
import { Error } from '@shared/interfaces/error.interface';
import { PhCropperComponent } from '@shared/components/ph-cropper/ph-cropper.component';
import { PhUploadComponent } from '@shared/components/ph-upload/ph-upload.component';
import { PhCropperOutputFile } from '@shared/components/ph-cropper/ph-cropper-output-file.interface';
import { ActivatedRoute } from '@angular/router';
import { PhTabsetComponent } from '@shared/components/ph-tabset/ph-tabset.component';
import { DescriptionComponent } from '@layouts/default/layouts/logged/pages/project/pages/create/components/description/description.component';
import { AdditionalInfoComponent } from '@layouts/default/layouts/logged/pages/project/pages/create/components/additional-info/additional-info.component';
import { LanguageService } from '@shared/services/language.service';
import { Organisation } from '@shared/interfaces/event/organisation.interface';
import { EventsService } from '@layouts/default/layouts/logged/pages/events/events.service';
import { VideoService } from '../../../services/video.service';
import { MenuService } from '@shared/services/menu.service';
import {ProjectsService} from "@layouts/default/layouts/guest/pages/projects/projects.service";

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateComponent extends BaseProjectComponent implements OnInit {
  @ViewChild('loadingProjectModal', {
    static: true,
  })
  displayLoadingProjectModal: boolean = false;
  displayFullYearModal: boolean = false;
  @ViewChild('additionalInfo', { static: true })
  additionalInfo: AdditionalInfoComponent;
  @ViewChild('tabsetCreate', { static: true })
  tabsetCreate: PhTabsetComponent;
  @ViewChild('descriptionSection', {
    static: true,
  })
  descriptionSection: DescriptionComponent;
  form: UntypedFormGroup = new UntypedFormGroup({});
  formImg: UntypedFormGroup = new UntypedFormGroup({});
  formTrash: UntypedFormGroup = new UntypedFormGroup({});
  countries: Countries[] = [];
  categories: Tag[] = [];
  range: Range[] = [];
  counterLoading: number = 0;
  mustLoad: number = 0;
  typeProject: string = 'draft';
  dateFromAfterImage: string = null;
  @ViewChild('phCropper', { static: true })
  phCropper: PhCropperComponent;
  @ViewChild('previewImg', { static: true })
  previewImg: PhUploadComponent;
  editMode: boolean = false;
  disabled: boolean = false;
  notAddedBags: boolean = true;
  disabledDraft: boolean = false;
  editProject: Project = null;
  metaTagsImages: any[] = [];
  imageNameIndex: number = 1;
  galleryStartIndex: number = 3;
  organisations: Organisation[] = [];
  beneficentEditId: number;
  isWcd = false;

  constructor(
    public route: ActivatedRoute,
    public fb: UntypedFormBuilder,
    public languageService: LanguageService,
    private eventService: EventsService,
    private readonly _videoService: VideoService,
    navigationService: MenuService,
    public projectsService: ProjectsService
  ) {
    super();
    this.getTags();
    this.getCountries();
    this.getOrganisations();
    this.isWcd = navigationService.isWcd();
    if (this.route.snapshot.url.filter(segment => segment.path === 'edit').length) {
      this.enableEditMode();
    }
  }

  ngOnInit() {
    this.setProjectDuration();
    const sub = this.languageService.langChangeEmitter.subscribe(() => {
      this.range = [];
      this.setProjectDuration();
    });
    this.someSubscriptions.add(sub);
  }

  @HostListener('window:beforeunload', ['$event'])
  public checkData() {
    if (this.form.touched) {
      return false;
    }
  }

  setProjectDuration() {
    this.range = [
      {
        name: this.translate.instant('PROJECT.10_days'),
        value: 10,
      },
      {
        name: this.translate.instant('PROJECT.20_days'),
        value: 20,
      },
      {
        name: this.translate.instant('PROJECT.30_days'),
        value: 30,
      },
      {
        name: this.translate.instant('PROJECT.45_days'),
        value: 45,
      },
      {
        name: this.translate.instant('PROJECT.60_days'),
        value: 60,
      },
      {
        name: this.translate.instant('PROJECT.90_days'),
        value: 90,
      },
      {
        name: this.translate.instant('PROJECT.120_days'),
        value: 120,
      },
      {
        name: this.translate.instant('PROJECT.180_days'),
        value: 180,
      },
    ];
  }

  enableEditMode() {
    this.editMode = true;
    const subData = this.projectsService
        .getProject(this.route.snapshot.params['id'])
        .subscribe((el: Response<Project>) => {
      const project = new Project(el.data);
      this.editProject = project;
      if (project.organization) {
        this.beneficentEditId = project.organization.id;
      }
      setTimeout(() => {
        this.formImg.get('previewImg').setValue(project.display_gallery_images[0]);
        this.formImg.get('beforeImg').setValue(project.display_gallery_images[1]);
        this.formImg.get('afterImg').setValue(project.display_gallery_images[2]);
        this.formImg.get('leaveTrashImg').setValue(project.display_gallery_images[3]);
        for (let i = this.imageNameIndex; i <= 50; i++) {
          this.formImg
            .get('additionalImg' + i)
            .setValue(project.display_gallery_images[this.galleryStartIndex + i]);
        }
        this.form.patchValue(project);
        this.form.get('categories').setValue(project.categories.map((el) => el.id));
      });
      if (this.editProject.status !== ProjectStatus.DRAFT) {
        this.router.navigate([RoutesPath.default.home]);
      }
    });
    this.someSubscriptions.add(subData);
  }

  getTags() {
    const subTag = this.projectService.enabledTagList().subscribe((res: Response<Tag[]>) => {
      this.categories = res.data;
      this.categories.forEach((tag, i) => {
        if (tag.name === 'citivolunteers') {
          this.categories.splice(i, 1);
        }
      });
    }, this.onTagError.bind(this));
    this.someSubscriptions.add(subTag);
  }

  getOrganisations() {
    const organisations = this.eventService
      .organisationsList()
      .subscribe((res: Response<Organisation[]>) => {
        this.organisations = res.data;
        if (this.beneficentEditId) {
          this.form.get('organization').setValue(this.beneficentEditId);
        }
      }, this.onTagError.bind(this));
    this.someSubscriptions.add(organisations);
  }

  getCountries() {
    const subCountries = this.accountService
      .allCountriesList()
      .subscribe((res: Response<Countries[]>) => {
        this.countries = res.data;
      }, this.onCountriesListError.bind(this));
    this.someSubscriptions.add(subCountries);
  }

  get validatePublishProject() {
    // mark all required variable
    this.form.markAllAsTouched();
    if (this.form.value.bags.length === 0) {
      this.formTrash.markAllAsTouched();
      this.notAddedBags = false;
    } else {
      this.notAddedBags = true;
    }
    if (
      !this.formImg.get('beforeImg').invalid &&
      !this.formImg.get('afterImg').invalid &&
      !this.formImg.get('previewImg').invalid &&
      !this.formImg.get('leaveTrashImg').invalid &&
      this.form.get('bags').invalid
    ) {
      this.tabsetCreate.changeTabName('description');
      setTimeout(() => {
        this.descriptionSection.bagsSection.nativeElement.scrollIntoView();
      });
    }
    this.formImg.markAllAsTouched();
    this.toast.error(
      this.translate.instant('PROJECT.required_publish'),
      this.translate.instant('PROJECT.required_request_error')
    );
    setTimeout(() => {
      this.disabled = false;
    }, 1000);
    return true;
  }

  get validateDraftProject() {
    // check if form with name of project have errors (only 'name' value must required for SaveToDraft)
    this.form.markAsUntouched();
    this.formImg.markAsUntouched();
    this.form.controls.name.markAsTouched({
      onlySelf: true,
    });
    this.toast.error(
      this.translate.instant('PROJECT.required_save_to_draft'),
      this.translate.instant('PROJECT.required_request_error')
    );
    setTimeout(() => {
      this.disabled = false;
      this.disabledDraft = false;
    }, 1000);
    return true;
  }

  get isLegal() {
    return this.storage.user.type === 'legal';
  }

  get validatorCreateProject() {
    if (this.typeProject === 'publish') {
      this.disabled = true;
      if (this.checkUserHaveAllInfo(this.storage.user)) {
        this.additionalInfo.displayAdditionalInfoModal = true;
        return true;
      }
      if (this.checkUserHaveAllYear(this.storage.user)) {
        this.displayFullYearModal = true;
        return true;
      }
      if (this.form.invalid || this.formImg.invalid) {
        return this.validatePublishProject;
      }
    }
    this.disabledDraft = true;
    if (this.typeProject === 'draft' && this.form.controls.name.invalid) {
      return this.validateDraftProject;
    }
    return false;
  }

  checkiOSversion() {
    // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
    if (
      /iPad|iPhone|iPod/.test(navigator.userAgent) &&
      // @ts-ignore
      !window.MSStream
    ) {
      if (!!window.indexedDB) {
        return 'iOS 8 and up';
      }
      // @ts-ignore
      if (!!window.SpeechSynthesisUtterance) {
        return 'iOS 7';
      }
      // @ts-ignore
      if (!!window.webkitAudioContext) {
        return 'iOS 6';
      }
      if (!!window.matchMedia) {
        return 'iOS 5';
      }
      if (!!window.history && 'pushState' in window.history) {
        return 'iOS 4';
      }
      return 'iOS 3 or earlier';
    }

    return 'Not an iOS device';
  }

  unlockButton() {
    this.disabled = false;
  }

  openLimpaForm() {
    window.open('https://forms.gle/vXEXKy32YUTRuU3d7', 'blank');
  }

  //HotFix - clear emptuy fields to null
  setNullInDescriptionFieldsValueIfEmpty() {
    if (this.form.get('description_one').value == '') {
      this.form.get('description_one').setValue(null);
    }
    if (this.form.get('description_two').value == '') {
      this.form.get('description_two').setValue(null);
    }
    if (this.form.get('description_three').value == '') {
      this.form.get('description_three').setValue(null);
    }
    if (this.form.get('description_four').value == '') {
      this.form.get('description_four').setValue(null);
    }
  }

  createProject(type: string = 'draft') {
    this.typeProject = type;
    this.setNullInDescriptionFieldsValueIfEmpty();
    if (this.validatorCreateProject) {
      return;
    }

    if (+this.storage.user.is_active === 2 && type === 'publish') {
      this.toast.error(this.translate.instant('PROJECT.cant_add_project_email_ver'));
      this.unlockButton();
      this.disabledDraft = false;
      return;
    }

    this.counterLoading = 0;
    const pack: Project = new Project(this.form.value);
    pack.video = this._videoService.correctVideoLink(pack.video);
    pack.status = ProjectStatus.DRAFT;
    const urlType = this.editMode
      ? this.projectService.editProject(pack, this.editProject.id)
      : this.projectService.newProject(pack);
    const subNewProject = urlType.subscribe((res: Response<Project>) => {
      const arrImg = Object.keys(this.formImg.value)
        .filter((el) => {
          if (this.editMode) {
            return this.formImg.value[el];
          }
          return this.formImg.value[el] && this.formImg.value[el] !== 'deleted';
        })
        .map(
          (key): UploadImg => ({
            imgData: this.formImg.value[key],
            container: key,
            data: this.metaTagsImages[key] ? this.metaTagsImages[key] : null,
            id: res.data.id,
            isIos: this.checkiOSversion(),
          })
        );
      arrImg.map((item: UploadImg, i) => {
        // array length can't be here, because, you can add to draft 1, 2 or 0 images
        // you must count it if 'imgData' is not null
        this.mustLoad++;
        this.uploadImg(item);
      });

      if (arrImg.length === 0) {
        this.projectPrepared(res.data);
      }
      this.displayLoadingProjectModal = true;
      this.disabled = false;
    }, this.onCreateProjectError.bind(this));
    this.someSubscriptions.add(subNewProject);
  }

  updateImagesDataTags(event: FileUploadSuccess) {
    this.metaTagsImages[event.name] = event.data;
  }

  onTagError(error: Error) {
    this.toast.error(
      this.translate.instant('ACCOUNT.tag_cant_get'),
      this.translate.instant('ACCOUNT.tag_error')
    );
  }

  onCountriesListError(error: Error) {
    this.toast.error(
      this.translate.instant('ACCOUNT.countries_cant_get'),
      this.translate.instant('ACCOUNT.countries_error')
    );
  }

  onCreateProjectError(error: Error) {
    this.displayLoadingProjectModal = false;
    this.disabled = false;
    this.disabledDraft = false;
    if (error?.message === 'user_mail_not_activated') {
      this.toast.error(this.translate.instant('PROJECT.cant_add_project_email_ver'));
      return;
    }
    let errorMaxCharacters = [];
    if (error.errors) {
      errorMaxCharacters = error.errors.map((el) => {
        if (el === 'this_value_is_too_long_it_should_have_255_characters_or_less') {
          this.toast.error(this.translate.instant('PROJECT.cant_add_project_name_long'));
          return;
        }
      });
    }
    if (errorMaxCharacters.length > 0) {
      return;
    }
    this.toast.error(this.translate.instant('PROJECT.cant_add_project'));
  }

  clearCounterLoading() {
    // clear counters, if closed modal
    this.counterLoading = 0;
    this.mustLoad = 0;
  }

  projectPrepared(pack) {
    if (this.typeProject === 'publish') {
      this.projectSetOnPublish(pack.id);
    } else {
      this.projectSuccess(pack.id);
    }
  }

  uploadImg(pack: UploadImg) {
    const subUploadImg = this.projectService.uploadImg(pack).subscribe((res: SuccessRes) => {
      this.counterLoading++;
      if (res.data && res.data.length > 0) {
        const subUploadImgData = this.projectService
          .updateImgData(pack, res.data[0].id)
          .subscribe((el) => {}, this.onUpdateImgDataError.bind(this));
        this.someSubscriptions.add(subUploadImgData);
      }
      if (this.mustLoad === this.counterLoading) {
        this.projectPrepared(pack);
      }
    }, this.onUploadError.bind(this));
    this.someSubscriptions.add(subUploadImg);
  }

  projectSetOnPublish(id) {
    const pack: ProjectPublish = {
      status: ProjectStatus.AWAITING,
    };
    const subProjectSetOnPublish = this.projectService
      .publishProject(pack, id)
      .subscribe((res: Response<Project>) => {
        this.projectSuccess(id);
      }, this.onProjectSetOnPublishError.bind(this));
    this.someSubscriptions.add(subProjectSetOnPublish);
  }

  onProjectSetOnPublishError(error: Error) {
    this.toast.error(
      this.translate.instant('PROJECT.cant_add_project_try_again'),
      this.translate.instant('PROJECT.project_error')
    );
  }

  onUpdateImgDataError(error: Error) {
    this.toast.error(this.translate.instant('PROJECT.cant_upload_img_data'));
  }

  checkWithDateImgAfter(event: UntypedFormControl) {
    function getDate(date) {
      return moment(date, Config.DATE_FORMAT_BACKEND).format('YYYY-MM-DD');
    }

    // if (this.dateFromAfterImage) {
    //   if (getDate(this.dateFromAfterImage) !== getDate(event.value)) {
    //     this.form.get('end_job_date').setErrors({incorrect: true});
    //     this.toast.error(this.translate.instant('PROJECT.date_img_error') + ' - ' + getDate(this.dateFromAfterImage));
    //   } else if (getDate(this.dateFromAfterImage) === getDate(event.value)) {
    //     this.form.get('end_job_date').setErrors(null);
    //   }
    // }
  }

  setProjectCreateData(event: FileUploadSuccess) {
    this.dateFromAfterImage = event.date;
    const formEl = this.form.get('end_job_date');
    if (!formEl.value && event.date) {
      formEl.setValue(this.dateFromAfterImage);
    } else if (event.date && event.date !== formEl.value) {
      formEl.setValue(event.date);
    }
  }

  projectSuccess(id) {
    if (+this.storage.user.is_active === 2 && this.storage.user.type === 'legal') {
      this.toast.success(
        this.translate.instant('PROJECT.project_save_to_draft_not_active_email'),
        this.translate.instant('PROJECT.project_success')
      );
    }
    setTimeout(() => {
      this.router.navigate([RoutesPath.default.in_review + '/' + id]);
    }, 2000);
  }

  onUploadError(error: Error) {
    this.toast.error(this.translate.instant('PROJECT.cant_upload_img'));
  }

  get projectStatusLoader() {
    if (this.mustLoad === 0) {
      return '0%';
    }
    return Math.ceil((this.counterLoading / this.mustLoad) * 100) + '%';
  }

  findCorrectPhUpload(event: PhCropperOutputFile) {
    this[event.name].fromCropper(event);
    this.phCropper.closeModal();
  }

  addToCropper(event) {
    this.phCropper.newImg(event);
  }
}
